<template>
	<div :class="['field-wrap', fieldWrapClass, error && 'error']">
		<slot name="label">
			<label>Heat Pump Water Heater Model</label>
		</slot>

		<div class="row no-gutters field-icon">
			<select
				:value="value"
				@change="onChange"
			>
				<option value="" disabled selected>Select a model...</option>
				<option
					v-for="[value, label] in hpwhModels"
					:key="value"
					:value="value"
					>
					{{label}}
				</option>
			</select>
		</div>

		<div class="suffix-wrap">
				<p class="desc"></p>

				<p class="label-error">
					<ErrorIcon />

					{{error}}
				</p>
		</div>
	</div>
</template>

<script>
import { reactive } from 'vue'
import jsonFetch from '@/utils/json-fetch'
import ErrorIcon from '@/components/ErrorIcon'

const modelsStore = reactive({
	singlepassModels: [],
	multipassModels: [],
})

export default {
	name: 'HPWHModelSelect',

	components: {
		ErrorIcon,
	},

	props: {
		multipass: {
			type: Boolean,
			default: false,
		},
		fieldWrapClass: String,
		value: String,
		onChange: {
			type: Function,
			default: () => null,
		},
		error: String,
	},

	computed: {
		hpwhModels () {
			const { multipass } = this
			const { singlepassModels, multipassModels } = modelsStore

			return multipass ? multipassModels : singlepassModels
		}
	},

	async created () {
		const { multipass } = this
		const { singlepassModels, multipassModels } = modelsStore

		if (!multipass && !singlepassModels.length) {
			modelsStore.singlepassModels = await jsonFetch({
				url: '/sizer/hpwhModelsList',
				method: 'GET'
			}).then(({ models }) => models)
		}

		if (multipass && !multipassModels.length) {
			modelsStore.multipassModels = await jsonFetch({
				url: '/sizer/hpwhModelsList/?mode=multipass',
				method: 'GET'
			}).then(({ models }) => models)
		}
	},
}
</script>
